import { render, staticRenderFns } from "./MultiPageFormPage.vue?vue&type=template&id=dce971da"
import script from "./MultiPageFormPage.vue?vue&type=script&lang=js"
export * from "./MultiPageFormPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports